module.exports = __webpack_public_path__ + "static/apple-touch-icon-a84f73a84919cc0db16f2c7c5d6e05bc.png";